<template>
    <div>
        <question :text="$t(item.text)" />
        <b-row align-h="center">
            <b-col cols="12" sm="10" md="8">
                <select-input
                    class="w-100"
                    :options="selectOptions"
                    :max="max"
                    :min="min"
                    @select="handleSelect"
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { ASSETS_URL } from '@/constants/misc'
import { CHOICE_RESULTS } from '@/constants/items'
import { getChoiceLabel } from '@/utils/items'

import selectInput from '@/components/inputs/select'
import question from '@/components/ui/question'

export default {
    name: 'multiChoiceItem',
    components: {
        question,
        'select-input': selectInput,
    },
    props: {
        item: {
            type: Object
        },
        itemProperties: {
            type: Object
        },
    },
    computed: {
        selectOptions() {
            return this.item.choices.map(choice => {
                return {
                    order: choice.order,
                    value: choice.result,
                    label: this.$t(choice.text),
                    icon: getChoiceLabel(choice, 'ICON') && ASSETS_URL + this.$t(getChoiceLabel(choice, 'ICON').text)
                }
            })
        },
        max() {
            const max = this.itemProperties.getProperty('multi_choice_max')
            return max ? parseInt(max) : 1
        },
        min() {
            const min = this.itemProperties.getProperty('multi_choice_min')
            return min ? parseInt(min) : 1
        },
    },
    methods: {
        handleSelect(values) {
            if(values.length >= this.min && values.length <= this.max) {

                const result = this.selectOptions.map(option => ({
                    result: values.indexOf(option.value) !== -1 ? CHOICE_RESULTS.TRUE : CHOICE_RESULTS.NONE,
                    choice: option.value,
                }))

                this.$emit('answer', result)
            } else {
                this.$emit('answer', null)
            }

        },
    },

}
</script>
<style lang="scss">

</style>